import React, { Component } from 'react';
import {
 Button, Input, RadioButton, RadioButtonGroup, Select,
} from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import moment from 'moment';
import {
  getInboundImpcsOfSingleOperator,
  getLeftPostalOperators,
  getLeftPostalOperatorsCodesOnly,
  getOutboundImpcsOfSingleOperator,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import { postRouteCreateRequestActionCreator } from '../redux/actions/RouteManagementCreateActions';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import '../../../../../sass/components/_forms.scss';
import {
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
} from '../../../../common/selection-criteria/impcs-per-operator/redux/actions/ImpcsOfSingleOperatorActions';
import TransferOperatorsContainer from '../../transfer-operators/TransferOperatorsContainer';
import filterIMPCCodesIfExistsInPostalOperators
  from '../../../../common/selection-criteria/operator-impc/mapper-filter/filterImpc';
import { retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator } from '../../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class RouteManagementCreateContainer extends Component {
  constructor(props) {
    super(props);

    const palletBoxData = props.appContext.appContext === 'pallet' ? {
      transferLocations: [],
    } : {};
    this.state = {
      outboundOperator: null,
      outboundImpc: null,
      inboundOperator: null,
      inboundImpc: null,
      ...palletBoxData,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: null,
      direction: 'ONEWAY',
      priority: 'PRIORITY',
      comment: '',
    };
  }

  componentDidMount() {
    if (this.props.appContext.appContext === 'pallet') {
      this.props.retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator();
    }
  }

  onOutboundOperatorChange = (selectedOption) => {
    this.props.getImpcsOfSingleOutboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      outboundOperator: selectedOption.value,
      outboundImpc: null,
    });
  }

  onOutboundImpcChange = (selectedOption) => {
    this.setState({
      outboundImpc: selectedOption.value,
    });
  }

  onInboundOperatorChange = (selectedOption) => {
    this.props.getImpcsOfSingleInboundOperatorRequestActionCreator(this.props.appContext.appContext, selectedOption.value);
    this.setState({
      inboundOperator: selectedOption.value,
      inboundImpc: null,
    });
  }

  onInboundImpcChange = (selectedOption) => {
    this.setState({
      inboundImpc: selectedOption.value,
    });
  }

  onTransferLocationChecked = (checkedTransferLocations) => {
    this.setState({
      transferLocations: filterIMPCCodesIfExistsInPostalOperators(
        checkedTransferLocations,
        this.props.operators,
      ),
    });
  }

  onStartDateChange = (newDate) => {
    this.setState({
      startDate: newDate,
    });
  }

  onEndDateChange = (newDate) => {
    this.setState({
      endDate: newDate,
    });
  }

  onPriorityTypeChange = (selectedOption) => {
    this.setState({
      priority: selectedOption.value,
    });
  }

  onDirectionChange = (e) => {
    this.setState({ direction: e.target.value });
  };

  onCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  }

  isFormValid = () => {
    let formValid = true;
    if (this.state.outboundOperator === null || this.state.outboundImpc === null || this.state.inboundOperator === null
      || this.state.inboundImpc === null || (this.state.startDate === null || this.state.startDate === 'Invalid Date')
      || this.state.endDate === 'Invalid Date') {
      formValid = false;
    }

    return formValid;
  }

  apply = () => {
    this.props.postRouteCreateRequestActionCreator(
      this.props.appContext,
      this.props.appContext.appContext === 'pallet' ? 'PALLET_BOX' : this.props.appContext.appContext.toUpperCase(),
      this.state.comment,
      this.state.direction,
      this.state.endDate,
      this.state.outboundImpc,
      this.state.inboundImpc,
      this.state.priority,
      this.state.startDate,
      this.state.transferLocations,
    );
    this.props.history.goBack();
  }

  mapImpcListToSelectOptions(listToMappedOptions) {
    const mappedList = [];
    listToMappedOptions.map((item) => {
      const impc = {
        label: item,
        value: item,
      };
      return mappedList.push(impc);
    });
    return mappedList;
  }

  render() {
    const priorityTypes = [
      { label: 'Priority', value: 'PRIORITY' },
      { label: 'Non priority', value: 'NONPRIORITY' },
      { label: 'Both', value: 'BOTH' },
    ];
    return (
      <div className="general-content-container">
        <h1 className="title-div">CREATE ROUTE</h1>
        <table className="edit-route-detail-form">
          <tbody>
            <tr>
              <td className="edit-route-input">Outbound Operator</td>
              <td className="edit-route-input">
                <Select
                  options={this.props.operators}
                  placeholder={this.state.outboundOperator}
                  value={this.state.outboundOperator}
                  onChange={this.onOutboundOperatorChange}
                />
              </td>
              <td className="edit-route-input">Outbound IMPC</td>
              <td className="edit-route-input">
                <Select
                  options={this.mapImpcListToSelectOptions(this.props.outboundImpcs.filter((item) => item !== this.state.inboundImpc))}
                  placeholder={this.state.outboundImpc}
                  value={this.state.outboundImpc}
                  onChange={this.onOutboundImpcChange}
                />
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Inbound Operator</td>
              <td className="edit-route-input">
                <Select
                  options={this.props.operators}
                  placeholder={this.state.inboundOperator}
                  value={this.state.inboundOperator}
                  onChange={this.onInboundOperatorChange}
                />
              </td>
              <td className="edit-route-input">Inbound IMPC</td>
              <td className="edit-route-input">
                <Select
                  options={this.mapImpcListToSelectOptions(this.props.inboundImpcs.filter((item) => item !== this.state.outboundImpc))}
                  placeholder={this.state.inboundImpc}
                  value={this.state.inboundImpc}
                  onChange={this.onInboundImpcChange}
                />
              </td>
            </tr>
            {this.props.appContext.appContext === 'pallet' && (
            <tr>
              <td className="edit-route-input">Transfer Locations</td>
              <td className="edit-route-input" colSpan={3}>
                <div className="transfer-operator-container">
                  <TransferOperatorsContainer
                    nodes={this.props.transferOperatorNodes}
                    checked={this.state.transferLocations}
                    onCheck={this.onTransferLocationChecked}
                  />
                </div>
              </td>
            </tr>
          )}
            <tr>
              <td className="edit-route-input">Direction</td>
              <td className="edit-route-input">
                <RadioButtonGroup defaultValue={this.state.direction} onChange={this.onDirectionChange}>
                  <RadioButton value="ONEWAY" label="One Way" />
                  <RadioButton value="BOTHWAYS" label="Both Ways" />
                </RadioButtonGroup>
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Start Date</td>
              <td className="edit-route-input">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                      value={this.state.startDate}
                      onChange={this.onStartDateChange}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
              <td className="edit-route-input">End Date</td>
              <td className="edit-route-input">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container>
                    <KeyboardDatePicker
                      disableToolbar
                      autoOk
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      value={this.state.endDate}
                      onChange={this.onEndDateChange}
                      minDate={this.state.startDate}
                      onError={this.onInvalidDate}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
            <tr>
              <td className="edit-route-input">Priority</td>
              <td>
                <Select
                  placeholder="Priority"
                  options={priorityTypes}
                  onChange={this.onPriorityTypeChange}
                />
              </td>
              <td className="edit-route-input">Comment</td>
              <td className="edit-route-input">
                <Input
                  value={this.state.comment}
                  onChange={this.onCommentChange}
                  maxLength={45}
                  style={{ width: '225px' }}
                />
              </td>
            </tr>
            {this.props.appContext.appContext === 'pallet' && (
            <tr>
              <td className="edit-route-input">Leading Count Type</td>
              <td className="edit-route-input">
                EDI
                <small> (Default Route leading count type is always EDI)</small>
              </td>
            </tr>
          )}
            <tr>
              <td className="edit-route-input">
                <Button onClick={this.props.history.goBack}>Cancel</Button>
              </td>
              <td className="edit-route-input">
                <Button
                  disabled={!this.isFormValid()}
                  className={`primary-button-${!this.isFormValid()}`}
                  onClick={this.apply}
                >
                  Confirm
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    operators: getLeftPostalOperatorsCodesOnly(state),
    transferOperatorNodes: getLeftPostalOperators(state),
    outboundImpcs: getOutboundImpcsOfSingleOperator(state),
    inboundImpcs: getInboundImpcsOfSingleOperator(state),
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator,
  getImpcsOfSingleOutboundOperatorRequestActionCreator,
  getImpcsOfSingleInboundOperatorRequestActionCreator,
  postRouteCreateRequestActionCreator,
}, dispatch);

RouteManagementCreateContainer.propTypes = {
  operators: PropTypes.arrayOf(PropTypes.object),
  transferOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  outboundImpcs: PropTypes.arrayOf(PropTypes.string),
  inboundImpcs: PropTypes.arrayOf(PropTypes.string),
  retrieveLeftAssetTypeOperatorsWithImpcsRequestActionCreator: PropTypes.func,
  getImpcsOfSingleOutboundOperatorRequestActionCreator: PropTypes.func,
  getImpcsOfSingleInboundOperatorRequestActionCreator: PropTypes.func,
  postRouteCreateRequestActionCreator: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  history: PropTypes.objectOf(PropTypes.shape),
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteManagementCreateContainer);
